import { PagingBaseModel } from '@shared/search-base';
import { FormService } from '@shared/services/forms/form.service';

export abstract class PagingCriteriaFormService<T extends PagingBaseModel> extends FormService<T> {}
